import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Returns true when the user has asked the OS to reduce motion.
 * Use this to gate non-essential animations (page transitions, slide-ins,
 * micro-interactions) so the app stays accessible and doesn't trigger
 * motion sickness. Updates live if the user changes the setting.
 */
export function usePrefersReducedMotion() {
  const getInitial = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(QUERY).matches
      : false;

  const [prefersReduced, setPrefersReduced] = useState(getInitial);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mql = window.matchMedia(QUERY);
    const onChange = () => setPrefersReduced(mql.matches);

    // Safari < 14 only supports the deprecated addListener API.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return prefersReduced;
}

export default usePrefersReducedMotion;
